import type { FC } from "react"

import { useCommunityCustomization } from "../utils/useCommunityCustomization"

const DEFAULT_SKELETON_BG = "bg-gray-400/40"

export const Skeleton: FC<{ className?: string }> = ({ className = "" }) => {
  const customizationData = useCommunityCustomization()
  const skeletonBg = customizationData?.styles.global.skeleton ?? DEFAULT_SKELETON_BG

  return <div className={`animate-pulse ${skeletonBg} ${className}`} />
}
